<script>
  import { onMount } from 'svelte';
  import { getApiUrl } from '../api';

  let enabled = true;

  onMount(async () => {
    const res = await fetch(getApiUrl('/qa/status'));
    const data = await res.json();
    enabled = data.enabled;
  });

  async function toggle() {
    enabled = !enabled;
    await fetch(getApiUrl('/qa/toggle'), {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ enabled })
    });
  }
</script>

<div class="container">
    <h2>Q&A Feature Settings</h2>
    <div class="card">
        <label class="switch">
            <input type="checkbox" bind:checked={enabled} on:change={toggle}>
            <span class="slider round"></span>
        </label>
        <span>Q&A is <strong>{enabled ? 'ON' : 'OFF'}</strong></span>
    </div>
</div>

<style>
    /* Reuse switch styles from other admin pages */
    .container { max-width: 600px; margin: 2rem auto; }
    .card { background: white; padding: 2rem; border-radius: 8px; display: flex; align-items: center; gap: 1rem; }
    .switch { position: relative; display: inline-block; width: 60px; height: 34px; }
    .switch input { opacity: 0; width: 0; height: 0; }
    .slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #ccc; transition: .4s; border-radius: 34px; }
    .slider:before { position: absolute; content: ""; height: 26px; width: 26px; left: 4px; bottom: 4px; background-color: white; transition: .4s; border-radius: 50%; }
    input:checked + .slider { background-color: #2196F3; }
    input:checked + .slider:before { transform: translateX(26px); }
</style>